import React from 'react';
import PageList from '../../../components/PageListAPI'
import { okeiList } from '../../../api/list'
import { useHistory, useLocation } from 'react-router-dom'
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function OkeiList() {
  const location = useLocation()
  const history = useHistory()
  return (
    <div className='App-paper'>
      <PageList
        name='region-list'
        columns={[
          { id: 'code', name: 'Код', },
          { id: 'name', name: 'Название единицы измерения', },
          { id: 'symbolNational', name: 'Национальное условное обозначение', },
          { id: 'symbolIntl', name: 'Международное условное обозначение', },
          { id: 'codeLetterNat', name: 'Национальное кодовое обозначение', },
          { id: 'codeLetterIntl', name: 'Международное кодовое обозначение', },
        ]}
        createItem={false}
        deleteItem={false}
        loadAPI={{
          request: okeiList,
        }}
        headerLink={<HeaderButton location={location} />}
        location={location}
        history={history}
      />
    </div>
  )
};

function HeaderButton({ location }) {
  const toLink = React.forwardRef((props1, ref) => (<Link ref={ref} to={location.pathname + '/upload'} {...props1} />));
  const toLinkMerge = React.forwardRef((props1, ref) => (<Link ref={ref} to={location.pathname + '/not'} {...props1} />));
  return <>
    <Button key='set-price' component={toLink} color="primary" >Обновить</Button>
    <Button key='set-price' component={toLinkMerge} color="primary" >Склеить</Button>
  </>
}